import cheerio from 'cheerio'

export const extractScriptSrc = htmlString => {
  // Load the HTML string into Cheerio
  const $ = cheerio.load(htmlString)

  // Find the script tag and extract the src attribute
  const scriptSrc = $('script').attr('src')

  return scriptSrc
}
